<div
  class="kr-wallet-card"
  [class.kr-wallet-card_large]="large()"
  [fuPopover]="large() ? null : popover"
  [position]="['bc']"
  [offsetY]="2">
  <img
    class="kr-wallet-card__img"
    src="assets/images/wallet-card.png"
    alt="Wallet card" />

  <div class="kr-wallet-card__header">
    <div class="kr-wallet-card__coin">
      <img
        [width]="large() ? '16' : '12'"
        [height]="large() ? '16' : '12'"
        [src]="wallet().coin?.image?.url"
        [alt]="wallet().coin?.image?.name" />

      <span class="kr-wallet-card__coin-name">
        {{ wallet().coin?.symbol }}
      </span>

      <span class="kr-wallet-card__coin-name">
        {{ getOrganizationTypeInitial(wallet().organizationType) }}
      </span>
    </div>

    @if (withEditBtn()) {
      <button
        class="kr-wallet-card__edit-btn"
        type="button"
        fuButton
        uiType="secondary"
        size="s"
        (click)="edit.emit()">
        <fu-icon iconName="edit" size="16" />
        {{ 'walletCard.btn.edit' | translate }}
      </button>
    }
  </div>

  <div
    class="kr-wallet-card__balance"
    [title]="
      wallet().balanceAvailable
        | balanceFormat: wallet().coin?.symbol
        | withDigitGroups: 3 : ','
    ">
    {{
      wallet().balanceAvailable
        | balanceFormat: wallet().coin?.symbol
        | withDigitGroups: 3 : ','
    }}
  </div>

  <p
    #name
    class="kr-wallet-card__name"
    [title]="walletName() || wallet().name"
    [attr.contenteditable]="editable()"
    (input)="walletNameChange.emit(name.innerText)">
    {{ wallet().name }}
  </p>
</div>

<ng-template #popover>
  <div class="kr-tooltip">
    <div class="kr-tooltip__item" (click)="clipboard.copy(wallet().address)">
      {{ 'walletCard.tooltip.address' | translate }}
      <fu-icon iconName="copy" size="16" />
    </div>
    <div class="kr-tooltip__item" (click)="clipboard.copy(wallet().id)">
      {{ 'walletCard.tooltip.name' | translate }}
      <fu-icon iconName="copy" size="16" />
    </div>
    <div class="kr-tooltip__item" (click)="clipboard.copy(wallet().name)">
      {{ 'walletCard.tooltip.id' | translate }}
      <fu-icon iconName="copy" size="16" />
    </div>
    <div class="kr-tooltip__item" (click)="dispatchClick()">
      {{ 'walletCard.tooltip.showInfo' | translate }}
      <fu-icon iconName="view" size="16" />
    </div>
  </div>
</ng-template>
